




// import React, { useEffect, useState } from 'react';
// import bannerImage from '../img/aaaservices/rea.webp';
// import OnlyButtonrange from './OnlyButtonrange';
// import jsPDF from "jspdf";

// const Banner = () => {
//   const [animate, setAnimate] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [step, setStep] = useState(1);
//   const [formData, setFormData] = useState({ email: '', phone: '' });
//   const [loading, setLoading] = useState(false);

//   const courseDetails = {
//     name: 'React / Flutter Programs',
//     description: 'React is one of the most widely-used programming languages.',
//     fee: '₹70000',
//   };

//   useEffect(() => {
//     setAnimate(true);
//   }, []);

//   const handleInputChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = () => {
//     setStep(2);
//   };

//   const handleBrochureDownload = () => {
//     const link = document.createElement('a');
//     link.href = '/brochure.docx';
//     link.setAttribute('download', 'Education-Brochure.docx');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const generatePDF = () => {
//     const doc = new jsPDF();
//     doc.text("Payment Successful", 20, 20);
//     doc.save("invoice.pdf");
//   };

//   const initiatePayment = async () => {
//     setLoading(true);

//     const options = {
//       key: "rzp_test_oqm83qg9Z710lA",
//       amount: 1 * 100,
//       currency: "INR",
//       name: "International Institute Of Automate",
//       handler: async function () {
//         alert("Payment Successful");
//         generatePDF();
//       },
//       theme: { color: "#3399cc" },
//     };

//     const pay = new window.Razorpay(options);
//     pay.open();
//   };

//   return (
//     <>
//       <style>{`
//         .banner-container {
//           position: relative;
//           width: 100%;
//           height: 600px;
//           overflow: hidden;
//         }

//         .banner-image {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .banner-overlay {
//           position: absolute;
//           inset: 0;
//           background: rgba(5, 42, 102, 0.5);
//           z-index: 1;
//         }

//         .banner-text {
//           position: absolute;
//           bottom: 18%;
//           left: 5%;
//           color: white;
//           z-index: 2;
//           max-width: 600px;
//           opacity: 0;
//           transform: translateY(40px);
//           transition: 0.8s ease;
//         }

//         .banner-text.animate {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         .banner-heading {
//           font-size: 32px;
//           font-weight: bold;
//           line-height: 1.3;
//         }

//         .banner-subheading {
//           font-size: 16px;
//           margin-top: 12px;
//           line-height: 1.6;
//         }

//         .button-group {
//           display: flex;
//           gap: 12px;
//           margin-top: 20px;
//           flex-wrap: wrap;
//         }

//         .banner-button {
//           background: #ffa200;
//           color: white;
//           padding: 12px 22px;
//           border-radius: 999px;
//           border: none;
//           font-weight: 600;
//           cursor: pointer;
//           font-size: 15px;
//           transition: 0.3s;
//         }

//         .banner-button:hover {
//           background: #e59400;
//         }

//         /* TRANSPARENT BOX */
//         .transparent-box {
//           position: absolute;
//           top: 140px;
//           right: 4%;
//           width: 280px;
//           background: rgba(255, 255, 255, 0.15);
//           padding: 20px;
//           color: #fff;
//           border-radius: 10px;
//           backdrop-filter: blur(6px);
//           z-index: 2;
//         }

//         .transparent-box h2 {
//           font-size: 20px;
//           margin-bottom: 10px;
//         }

//         .event-details {
//           list-style: none;
//           padding: 0;
//           margin: 0 0 15px 0;
//           font-size: 14px;
//           line-height: 1.6;
//         }

//         /* POPUP */
//         .popup-overlay {
//           position: fixed;
//           inset: 0;
//           background: rgba(0,0,0,0.6);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 999;
//         }

//         .popup-content {
//           background: white;
//           padding: 25px;
//           border-radius: 10px;
//           width: 100%;
//           max-width: 380px;
//         }

//         .form-step input {
//           width: 100%;
//           margin-bottom: 10px;
//           padding: 10px;
//           border-radius: 6px;
//           border: 1px solid #ccc;
//         }

//         .form-step button {
//           width: 100%;
//           padding: 10px;
//           background: #ffa200;
//           color: white;
//           border: none;
//           border-radius: 6px;
//           font-weight: bold;
//         }

//         /* MOBILE */
//         @media (max-width: 768px) {
//           .banner-container {
//             height: auto;
//             padding-bottom: 30px;
//           }

//           .banner-text {
//             position: relative;
//             left: auto;
//             bottom: auto;
//             text-align: center;
//             padding: 20px;
//             opacity: 1;
//             transform: none;
//           }

//           .transparent-box {
//             position: relative;
//             width: 90%;
//             margin: 20px auto;
//             top: auto;
//             right: auto;
//           }

//           .banner-heading {
//             font-size: 22px;
//           }

//           .banner-subheading {
//             font-size: 14px;
//           }

//           .button-group {
//             justify-content: center;
//           }
//         }
//       `}</style>

//       <div className="banner-container">
//         <img src={bannerImage} alt="Banner" className="banner-image" />
//         <div className="banner-overlay"></div>

//         {/* Transparent Box */}
//         {/* <div className="transparent-box">
//           <h2>React / Flutter Programs</h2>
//           <ul className="event-details">
//             <li><strong>Duration:</strong> 3 Months</li>
//             <li><strong>Languages:</strong> Telugu, English, Hindi</li>
//             <li><strong>Price:</strong> ₹70000 onwards</li>
//           </ul>
//           <button
//             className="banner-button"
//             onClick={() => setShowPopup(true)}
//           >
//             Book Now
//           </button>
//         </div> */}

//         {/* Banner Text */}
//         <div className={`banner-text ${animate ? 'animate' : ''}`}>
//           <h1 className="banner-heading">
//             Industry Insights on React / Flutter Programs
//           </h1>
//           <p className="banner-subheading">
//             React JS is a leading JavaScript library for building interactive user interfaces, widely adopted across industries like web development, e-commerce, and social media platforms. With its component-based architecture and virtual DOM, React offers fast and efficient performance for dynamic web applications. As web applications continue to evolve, React’s simplicity and versatility make it an essential tool for developers
//           </p>
// <div className="star-rating">⭐⭐⭐⭐⭐</div>
//           <div className="button-group">
//             <button
//               className="banner-button"
//               onClick={handleBrochureDownload}
//             >
//               Brochure
//             </button>
//             <button
//               className="banner-button"
//               onClick={() => window.location.href = '/Fluttercontact'}
//             >
//               Enquiry
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Popup */}
//       {showPopup && (
//         <div className="popup-overlay">
//           <div className="popup-content">
//             {step === 1 ? (
//               <div className="form-step">
//                 <h3>Enter Details</h3>
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                 />
//                 <input
//                   type="tel"
//                   name="phone"
//                   placeholder="Phone"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                 />
//                 <button onClick={handleSubmit}>Submit</button>
//               </div>
//             ) : (
//               <div className="form-step">
//                 <h3>Confirm & Pay</h3>
//                 <button
//                   onClick={initiatePayment}
//                   disabled={loading}
//                 >
//                   {loading ? "Processing..." : "Pay Now"}
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       <div className="button-range-wrapper">
//         <OnlyButtonrange />
//       </div>
//     </>
//   );
// };

// export default Banner;



import React, { useEffect, useState } from 'react';
import bannerImage from '../img/aaaservices/rea.webp';
import OnlyButtonrange from './OnlyButtonrange';
import jsPDF from "jspdf";

const Banner = () => {
  const [animate, setAnimate] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ email: '', phone: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => setAnimate(true), []);

  const handleInputChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = () => setStep(2);

  const handleBrochureDownload = () => {
    const link = document.createElement('a');
    link.href = '/brochure.docx';
    link.setAttribute('download', 'Education-Brochure.docx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    doc.text("Payment Successful", 20, 20);
    doc.save("invoice.pdf");
  };

  const initiatePayment = () => {
    setLoading(true);
    const options = {
      key: "rzp_test_oqm83qg9Z710lA",
      amount: 100,
      currency: "INR",
      name: "International Institute Of Automate",
      handler: function () {
        alert("Payment Successful");
        generatePDF();
      },
      theme: { color: "#3399cc" },
    };
    new window.Razorpay(options).open();
  };

  return (
    <>
      <style>{`
        /* ===== BANNER ROOT ===== */
        .banner-container {
          position: relative;
          width: 100%;
          min-height: 600px;
          overflow: hidden;
        }

        /* ===== IMAGE ===== */
        .banner-image {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* ===== OVERLAY ===== */
        .banner-overlay {
          position: absolute;
          inset: 0;
          background: rgba(5, 42, 102, 0.5);
          z-index: 1;
        }

        /* ===== CONTENT ===== */
        .banner-text {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 0 6% 8%;
          max-width: 650px;
          color: #fff;
          opacity: 0;
          transform: translateY(40px);
          transition: 0.8s ease;
        }

        .banner-text.animate {
          opacity: 1;
          transform: translateY(0);
        }

        .banner-heading {
          font-size: 32px;
          font-weight: 700;
          line-height: 1.3;
        }

        .banner-subheading {
          font-size: 16px;
          margin-top: 14px;
          line-height: 1.7;
        }

        .star-rating {
          color: gold;
          font-size: 18px;
          margin-top: 10px;
        }

        .button-group {
          display: flex;
          gap: 15px;
          margin-top: 22px;
          flex-wrap: wrap;
        }

        .banner-button {
          background: #ffa200;
          color: #fff;
          padding: 12px 22px;
          border-radius: 999px;
          border: none;
          font-weight: 600;
          cursor: pointer;
          font-size: 15px;
        }

        /* ===== POPUP ===== */
        .popup-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
          padding: 20px;
        }

        .popup-content {
          background: white;
          padding: 25px;
          border-radius: 10px;
          width: 100%;
          max-width: 380px;
        }

        .form-step input {
          width: 100%;
          margin-bottom: 10px;
          padding: 10px;
          border-radius: 6px;
          border: 1px solid #ccc;
        }

        .form-step button {
          width: 100%;
          padding: 10px;
          background: #ffa200;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: bold;
        }

        /* ===== MOBILE FIX ===== */
        @media (max-width: 768px) {
          .banner-container {
            min-height: 100vh;
          }

          .banner-text {
            justify-content: center;
            padding: 20px;
            text-align: center;
            max-width: 100%;
          }

          .banner-heading {
            font-size: 22px;
          }

          .banner-subheading {
            font-size: 14px;
          }

          .button-group {
            justify-content: center;
          }
        }
      `}</style>

      {/* ===== BANNER ===== */}
      <section className="banner-container">
        <img src={bannerImage} alt="Banner" className="banner-image" />
        <div className="banner-overlay"></div>

        <div className={`banner-text ${animate ? 'animate' : ''}`}>
          <h1 className="banner-heading">
            Industry Insights on React / Flutter Programs
          </h1>

          <p className="banner-subheading">
            React JS is a leading JavaScript library for building interactive user interfaces, widely adopted across industries like web development, e-commerce, and social media platforms. With its component-based architecture and virtual DOM, React offers fast and efficient performance for dynamic web applications. As web applications continue to evolve, React’s simplicity and versatility make it an essential tool for developers
          </p>

          <div className="star-rating">⭐⭐⭐⭐⭐</div>

          <div className="button-group">
            <button className="banner-button" onClick={handleBrochureDownload}>
              Brochure
            </button>
            <button
  className="banner-button"
  onClick={() => {
    const name = "IIA-Team";
    const mobile = "8096120173";

    const confirmCall = window.confirm(
      `Call Details:\n\nName: ${name}\nMobile: ${mobile}\n\nDo you want to call now?`
    );

    if (confirmCall) {
      window.location.href = `tel:${mobile}`;
    }
  }}
>
  Call Now
</button>
          </div>
        </div>
      </section>

      {/* ===== POPUP ===== */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            {step === 1 ? (
              <div className="form-step">
                <h3>Enter Details</h3>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
                <button onClick={handleSubmit}>Submit</button>
              </div>
            ) : (
              <div className="form-step">
                <h3>Confirm & Pay</h3>
                <button onClick={initiatePayment} disabled={loading}>
                  {loading ? "Processing..." : "Pay Now"}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="button-range-wrapper">
         <OnlyButtonrange />
       </div>
    </>
  );
};

export default Banner;

